import { types } from 'mobx-state-tree';

export const LoadableStatus = {
    init: 'init',
    loading: 'loading',
    done: 'done',
    error: 'error',
};

export const loadable = (Type, fetchFlow) => {
    const Loadable = types.optional(
        types
            .model({
                data: types.maybe(types.maybeNull(Type)),
                status: types.optional(
                    types.enumeration(Object.values(LoadableStatus)),
                    LoadableStatus.init,
                ),
                fallback: types.maybe(Type),
            })
            .actions((self) => ({
                fetch: (...args) => fetchFlow(self, ...args),
                setData: (data) => (self.data = data),
                resetData: () => {
                    self.data = undefined;
                    self.status = LoadableStatus.init;
                },
                setStatus: (status) => (self.status = status),
                setFallback: (fallback) => (self.fallback = fallback),
            })),
        { status: LoadableStatus.init },
    );

    return Loadable;
}
